// extracted by mini-css-extract-plugin
export var dropdownButton = "_2z-0";
export var fullWidthDropdownButton = "_2z-1";
export var icon = "_2z-3";
export var iconPlaceholder = "_2z-2";
export var menuItemRow = "_2z-9";
export var separator = "_2z-e";
export var shortcutContainer = "_2z-7";
export var shortcutContainerFilled = "_2z-8";
export var shortcutIconLg = "_2z-6";
export var shortcutIconMd = "_2z-5";
export var shortcutIconSm = "_2z-4";
export var submenuChevron = "_2z-d";
export var submenuDropdown = "_2z-a";
export var submenuTriggerRow = "_2z-b";
export var submenuTriggerRowOpen = "_2z-c";